/* eslint-disable react/jsx-props-no-spreading */
import { type FC, type ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type TextFieldProps = {
  name: string;
  errorName?: string;
  placeholder: string;
  requiredErrorMessage?: string;
  isError?: boolean;
  isDisabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  patternValidation?: { value: RegExp; message: string };
};

export const TextField: FC<TextFieldProps> = ({
  name,
  errorName,
  placeholder,
  requiredErrorMessage,
  isError,
  isDisabled,
  onChange,
  patternValidation,
}) => {
  const { register, clearErrors } = useFormContext();
  const deleteErrorMessage = () => {
    if (errorName) {
      // この項目と連動する他のエラーメッセージを削除する場合はerrorNameで指定する
      clearErrors(errorName);
    }
    clearErrors(name);
  };
  return (
    <input
      type="text"
      className={styles.textField[isError ? "error" : "default"]}
      placeholder={placeholder}
      disabled={isDisabled}
      {...register(name, {
        pattern: patternValidation,
        required: requiredErrorMessage,
        onChange: (e: ChangeEvent<HTMLInputElement>) => {
          if (onChange) onChange(e);
          deleteErrorMessage();
        },
      })}
    />
  );
};
